import React, { ChangeEvent } from "react";

import { Panel, PanelCollapsibleArea, PanelLabel } from "./list-panel";

import RadioInput from "@stadium/ui/src/components/form/RadioInput";
import FormLabel from "@sharedComponents/form-label";
import CheckboxList from "@components/store/sidebar/checkbox-listing";
import Multimedia from "@components/shared/multimedia";

import styles from "./main.module.scss";
interface ItemType extends Object {
  id: string;
  name: string;
  getName?: Function;
  label?: string;
  icon?: string;
  externalId?: string;
  options?: { name: string; id: string; label: React.ReactNode }[];
  logoSrc?: string;
}

interface RadioProps {
  id: string;
  items: ItemType[];
  // eslint-disable-next-line no-unused-vars
  onChange: (args: unknown) => void;
  label: string;
  selectedIds: string[];
  disabled?: boolean;
  defaultOpen?: boolean;
  // eslint-disable-next-line no-unused-vars
  handleChecked: (
    key: string,
    id: string,
    callback: (args: unknown) => unknown,
    optionIds: string[],
    _e: ChangeEvent,
  ) => void;
  maxItemsToShow?: number;
}

const RadioInputList: React.FC<RadioProps> = ({
  id: key,
  items,
  onChange,
  label,
  selectedIds,
  handleChecked,
  disabled,
  defaultOpen,
  maxItemsToShow,
}) => {
  return (
    <Panel
      className={`${styles.dropdownFilter} ${styles.filterByDropdown}`}
      eventKey={key}
      defaultOpen={defaultOpen}
    >
      <PanelLabel className={styles.panelLabel} disabled={disabled} id={key}>
        {label}
      </PanelLabel>
      <PanelCollapsibleArea eventKey={key} className={styles.checkListWrapper}>
        <div className={styles.listingPanel}>
          {items.map((item) => {
            const { id, name, label, getName, options = [], logoSrc } = item || {};
            const optionIds = options.map(({ id }) => id);

            const optionParams = {
              key: id,
              items: options,
              onChange,
              selectedIds,
              handleChecked,
              disabled: false,
              defaultOpen: true,
              maxItemsToShow,
            };
            const isParentSelected = selectedIds.some((selectedId) =>
              [id, ...optionIds].includes(selectedId),
            );
            const showChildOptions = options.length > 1 && isParentSelected;
            return (
              <>
                <RadioInput
                  id={id}
                  checked={isParentSelected}
                  key={`radio-${label}-${id}`}
                  name={id}
                  classes={styles.customRadio}
                  value={id}
                  onChange={({ name, value, _e }) =>
                    handleChecked(name, value, onChange, optionIds, _e)
                  }
                  label={
                    <FormLabel className={styles.radioLabel} iconType="radioOutline">
                      {logoSrc && (
                        <div className={styles.coreImage}>
                          <Multimedia src={logoSrc} alt={label} type="image" />
                        </div>
                      )}
                      <span className={styles.radioLabelValue}>{name || getName?.(label)}</span>
                    </FormLabel>
                  }
                />
                {showChildOptions ? <CheckboxList {...optionParams} id={id} /> : ""}
              </>
            );
          })}
        </div>
      </PanelCollapsibleArea>
    </Panel>
  );
};

export default RadioInputList;
